import React from 'react';
import { Joyride } from 'react-joyride';

export const FeatureGuidelines = () => {
    const steps = [
        {
            target: '.farm-selector',
            content: (
                <div>
                    <h4>Select Your Farm</h4>
                    <p>Before running AI analysis, pick your target farm location.</p>
                    <img src="/assets/placeholder-guide.jpg" alt="Guide" width="100%" />
                </div>
            ),
        },
        {
            target: '.leaf-camera-btn',
            content: 'Take a picture of the plant leaf to detect potential diseases instantly.',
        }
    ];

    return (
        <Joyride
            steps={steps}
            continuous={true}
            showSkipButton={true}
            styles={{
                options: {
                    primaryColor: '#C47A2C', // Using geo-copper 
                    textColor: '#1B263B',    // Ensuring readable text
                    backgroundColor: '#fff'
                }
            }}
        />
    );
};
